/* @ngInject */
const reverse = () => {
  return (items) => {
    return items.slice().reverse()
  }
}

export default reverse



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/filters/utils/reverse.filter.js